import { render, staticRenderFns } from "./controller.vue?vue&type=template&id=23226956&scoped=true"
import script from "./controller.vue?vue&type=script&lang=js"
export * from "./controller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23226956",
  null
  
)

export default component.exports